(function initAesLearnMoreSwiper() {
  var maxAttempts = 20;
  var retryDelayMs = 120;

  function initSwiperForSection(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.aesLearnMoreReady === 'true') return;

    var swiperElement = sectionRoot.querySelector('[data-aes-learn-more-swiper]');
    if (!swiperElement) return;

    var scrollbarEl = sectionRoot.querySelector('.aes-learn-more__scrollbar');
    if (!scrollbarEl) return;

    sectionRoot.dataset.aesLearnMoreReady = 'true';
    sectionRoot.aesLearnMoreSwiper = new Swiper(swiperElement, {
      slidesPerView: 3.3,
      spaceBetween: 10,
      grabCursor: true,
      allowTouchMove: true,
      freeMode: {
        enabled: true,
        momentum: true,
      },
      watchOverflow: true,
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        dragSize: 'auto',
      },
      breakpoints: {
        768: {
          spaceBetween: 25,
          slidesPerView: 2.5,
        },
        1200: {
          spaceBetween: 33,
          slidesPerView: 4,
        },
      },
    });
  }

  function mountAll(attempt) {
    if (typeof Swiper === 'undefined') {
      if (attempt < maxAttempts) {
        window.setTimeout(function retryInit() {
          mountAll(attempt + 1);
        }, retryDelayMs);
      }
      return;
    }

    document.querySelectorAll('.article-editorial-sidebar').forEach(function (sectionRoot) {
      initSwiperForSection(sectionRoot);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function onAesReady() {
      mountAll(0);
    });
  } else {
    mountAll(0);
  }

  document.addEventListener('shopify:section:load', function onSectionLoad(event) {
    var target = event && event.target;
    if (!target || !target.matches || !target.matches('.article-editorial-sidebar')) return;

    target.dataset.aesLearnMoreReady = '';
    if (target.aesLearnMoreSwiper && typeof target.aesLearnMoreSwiper.destroy === 'function') {
      target.aesLearnMoreSwiper.destroy(true, true);
      target.aesLearnMoreSwiper = null;
    }
    mountAll(0);
  });
})();